import { chatTypes } from '../../types';

export const MAIN_CHAT_FILTER_NAMES = {
  external: 'external',
  internalNotes: 'internalNotes',
  internalLogs: 'internalLogs'
};

const defaultState = {
  mainChatFilters: {
    [MAIN_CHAT_FILTER_NAMES.external]: true,
    [MAIN_CHAT_FILTER_NAMES.internalNotes]: true,
    [MAIN_CHAT_FILTER_NAMES.internalLogs]: true
  }
};

const map = {
  [chatTypes.SET_MAIN_CHAT_FILTERS]: (state, { payload }) => ({
    ...state,
    mainChatFilters: { ...state.mainChatFilters, ...payload }
  })
};

export default (state = defaultState, action) =>
  (map[action.type] && map[action.type](state, action)) || state;
